/** Receptionist phone call logs directory — shared by table and column picker. */
export const RECEPTIONIST_CALL_LOG_TABLE_HEADERS = [
  { key: "call_date", label: "Call date" },
  { key: "call_time", label: "Time" },
  { key: "caller", label: "Caller" },
  { key: "contact_number", label: "Phone" },
  { key: "call_type", label: "Call type" },
  { key: "purpose", label: "Purpose" },
  { key: "contact_person", label: "Contact person" },
  { key: "call_duration", label: "Duration" },
  { key: "status", label: "Status" },
  { key: "follow_up_date", label: "Follow-up date" },
  { key: "follow_up_assigned_to", label: "Follow-up assigned to" },
  { key: "action_taken", label: "Action taken" },
  { key: "remarks", label: "Remarks" },
  { key: "actions", label: "Actions", className: "occl-col-actions" },
];
